<template>
    <div class="modal-container-cont">
        <div class="modal-container">
           <!--  <div class="modal-form-container">
                <div class="title-box">
                    <h2>{{ getString('login_consumidor') }}</h2>
                </div>
            </div> -->
            <div class="modal-body">
                <component :is="currentComponent" @loginSuccess="loginSuccess()" @cancelLogin="cancelLogin($event)"
                    @disableOverlayClick="$emit('disableOverlayClick')" @enableOverlayClick="$emit('enableOverlayClick')"
                    @changeMethod="changeMethod()" />
            </div>
        </div>
    </div>
</template>

<script>

import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'
import LocaleController from '@/assets/controllers/LocaleController'
import ConsumerLoginBadge from './ConsumerLoginBadge.vue'
import ConsumerLoginPassword from './ConsumerLoginPassword.vue'
import ConsumerLoginFaceRecognition from './ConsumerLoginFaceRecognition.vue'
export default {
    name: 'ConsumerLogin',
    components: {
        DefaultButton,
        ConsumerLoginBadge,
        ConsumerLoginPassword,
        ConsumerLoginFaceRecognition
    },
    props: [
        'preSelectedMethod'
    ],
    data () {
        return {
            method: 'password', /* password, faceRecognition, badgeNumber */
            controlsEnabled: true,
            loggedSuccessfully: false,
            faceDetection: false,
            useFaceRecognition: Util.getLocalConfigs('useFaceRecognition') || false,
            lockKeyboardCons: Util.isLockKeyboardCons() || false,
            currentComponent: null
        }
    },
    mounted () {
        if (this.preSelectedMethod) {
            this.method = this.preSelectedMethod
        }
        this.loadMethod()
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        startFaceRecognition: function () {
            this.method = 'faceRecognition'
            this.faceDetection = true
        },
        loadMethod () {
            if (this.method === 'faceRecognition') {
                this.faceDetection = true
                this.currentComponent = 'ConsumerLoginFaceRecognition'
            } else if (this.method === 'password') {
                this.faceDetection = false
                this.currentComponent = 'ConsumerLoginPassword'
            } else if (this.method === 'badgeNumber') {
                this.faceDetection = false
                this.currentComponent = 'ConsumerLoginBadge'
            }
        },
        loginSuccess: function () {
            this.$emit('loginSuccess')
        },
        cancelLogin: function (error = false) {
            this.loggedSuccessfully = false
            this.$emit('cancelLogin', error)
        },
        changeMethod: function () {
            this.faceDetection = false
            if (this.method === 'faceRecognition' && this.lockKeyboardCons) {
                this.method = 'badgeNumber'
            } else if (this.method === 'faceRecognition' && !this.lockKeyboardCons) {
                this.method = 'password'
            }
            this.loggedSuccessfully = false

            this.loadMethod()
            this.$emit('changeMethod', this.method)
        }
    }
}
</script>

<style scoped lang='less'>
@import (reference) url("../../assets/common.less");

.modal-container-cont {
    height: 100%;
    min-height: 0;
    padding: 8px 30px;
    box-sizing: border-box;

    .modal-container {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        height: 100%;
        min-height: 0;
    }

    .modal-form-container {
        flex: 0 0 auto;
        position: relative;
        overflow: hidden auto;

        .title-box {
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;

            h2 {
                color: @primary-dark;
                margin: auto;
                font-size: 40px;
            }
        }
    }

    /* Ocupa só o espaço abaixo do título; sem isso height:100% no filho soma título+conteúdo e estoura o pai */
    .modal-body {
        flex: 1 1 0%;
        min-height: 0;
        min-width: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }
}

@media (max-width: 698px) {
    .modal-container-cont .modal-container {
        margin: auto;
        padding: 0px 30px;

        .modal-form-container {
            .title-box {
                height: 50px;

                h2 {
                    font-size: 25px;
                }
            }
        }

        .new-login-button {
            margin: 0px auto 20px auto;
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    .modal-container-cont .modal-container {
        margin: auto 25px;

        .modal-form-container {
            .title-box {
                height: 100px;

                h2 {
                    font-size: 35px;
                }
            }
        }

        .new-login-button {
            margin: 0 auto 30px auto;
        }
    }
}

@media (orientation: landscape) and (max-width: 1025px) {
    .modal-container-cont .modal-container {
        margin: auto 12px;

        .modal-form-container {
            .title-box {
                height: 36px;

                h2 {
                    font-size: 20px;
                    margin: 0;
                }
            }
        }

        .new-login-button {
            margin: 0 auto 10px auto;
        }
    }
}

@media (orientation: landscape) and (min-width: 1026px) and (max-width: 1367px) {
    .modal-container-cont .modal-container {
        margin: auto 48px;

        .modal-form-container {
            .title-box {
                height: 42px;

                h2 {
                    font-size: 24px;
                    margin: 0;
                }
            }
        }

        .new-login-button {
            margin: 0 auto 14px auto;
        }
    }
}

@media (orientation: landscape) and (min-width: 1368px) {
    .modal-container-cont .modal-container {
        margin: auto 100px;

        .modal-form-container {
            .title-box {
                height: 48px;

                h2 {
                    font-size: 26px;
                    margin: 0;
                }
            }
        }

        .new-login-button {
            margin: 0 auto 18px auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/consumerLogin/ConsumerLogin.vue